import { render } from "./SingleType.vue?vue&type=template&id=5cfd5090&scoped=true"
import script from "./SingleType.vue?vue&type=script&lang=js"
export * from "./SingleType.vue?vue&type=script&lang=js"

import "./SingleType.vue?vue&type=style&index=0&id=5cfd5090&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfd5090"]])

export default __exports__